<template>
  <div>
    <LoadingBox v-if="isLoading" />

    <CoursesList
      :courses="courses"
      :isBusy="isBusy"
      v-slot="{ course }"
      @next="fetchUserCourseHistory"
    >
      <CourseThumbWithProgress :course="course" />
    </CoursesList>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { getUserCourseWatchHistory } from '@/api/user.api'
  import LoadingBox from '@/components/layout/LoadingBox'
  import CourseThumbWithProgress from '@/components/course/CourseThumbWithProgress'
  import CoursesList from '@/components/course/CoursesList'

  export default {
    components: {
      LoadingBox,
      CourseThumbWithProgress,
      CoursesList,
    },
    
    data: () => ({
      isLoading: false,
      isFinished: false,
      courses: [],
      page: 1
    }),

    mounted () {
      this.fetchUserCourseHistory()
    },

    computed: {
      ...mapGetters('user', ['user']),

      isBusy () {
        return this.isFinished || this.isLoading
      }
    },

    methods: {
      async fetchUserCourseHistory () {
        this.isLoading = true

        const res = await getUserCourseWatchHistory('me', this.page++)

        if (!res.data.links.next) {
          this.isFinished = true
        }

        this.isLoading = false

        res.data.data.map(c => this.courses.push(c))
      }
    }
  }
</script>